"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var useKey_1 = tslib_1.__importDefault(require("./useKey"));

var useKeyPress = function useKeyPress(keyFilter) {
  var _a = react_1.useState([false, null]),
      state = _a[0],
      set = _a[1];

  useKey_1["default"](keyFilter, function (event) {
    return set([true, event]);
  }, {
    event: 'keydown'
  }, [state]);
  useKey_1["default"](keyFilter, function (event) {
    return set([false, event]);
  }, {
    event: 'keyup'
  }, [state]);
  return state;
};

exports["default"] = useKeyPress;